module.exports = __webpack_public_path__ + "img/icon_paihangbang.ac523e29.svg";